var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c(_setup.Layout, [_c(_setup.CustomTemplateWithLeftBlock, {
    attrs: {
      "aside-width": "380px",
      "menu-offset": ""
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };